var map = {
	"./music-instructions.json": 4829,
	"./music-library-intro2024.json": 4830,
	"./music-library-launch2024.json": 4831,
	"./music-progression.json": 4832,
	"./startSourcesAdvanced.json": 4833,
	"./startSourcesSimple.json": 4834,
	"./startSourcesSimple2.json": 4835,
	"./startSourcesTracks.json": 4836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4522;